import { render, staticRenderFns } from "./stockStatusSummery.vue?vue&type=template&id=5c5fc2cb&scoped=true"
import script from "./stockStatusSummery.vue?vue&type=script&lang=js"
export * from "./stockStatusSummery.vue?vue&type=script&lang=js"
import style0 from "./stockStatusSummery.vue?vue&type=style&index=0&id=5c5fc2cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5fc2cb",
  null
  
)

export default component.exports